import { combineReducers } from "redux";
import experience from './experience';


export default combineReducers({ experience });
